import { useQuery } from '@tanstack/react-query';
import { data, useLoaderData, useNavigate, type LoaderFunctionArgs } from 'react-router';
import { useTranslation } from 'react-i18next';
import { Button } from '@artosera/ui';
import type { SessionUtilisateur } from '../../api/types.js';
import { galerieALaction, galerieAModule } from '../../auth/sujet.js';
import { trouverGalerie, lireSessionVerifiee } from '../../auth/session.js';
import { CLE_SESSION } from '../../auth/queryClient.js';
import { chargerCoquille } from '../loaders.js';
import { ListeRegistre } from './ListeRegistre.js';
import styles from './RegistrePolice.module.css';

export async function controleLoader({ request, params }: LoaderFunctionArgs) {
  const donnees = await chargerCoquille(request.url, params['slug']);
  const galerie = trouverGalerie(donnees.session, donnees.galerieSlug);
  if (
    !galerie ||
    !galerieAModule(galerie, 'registre-police') ||
    !galerieALaction(galerie, 'registre-police:read')
  )
    throw data(null, { status: 403 });
  return donnees;
}
export function ControlePage() {
  const { galerieSlug } = useLoaderData<typeof controleLoader>();
  const { data: session } = useQuery<SessionUtilisateur>({
    queryKey: CLE_SESSION,
    queryFn: lireSessionVerifiee,
    enabled: false,
    staleTime: Infinity,
  });
  const galerie = session ? trouverGalerie(session, galerieSlug) : null;
  const { t } = useTranslation('regie');
  const naviguer = useNavigate();
  const peutLire = Boolean(
    galerie &&
    galerieAModule(galerie, 'registre-police') &&
    galerieALaction(galerie, 'registre-police:read'),
  );
  return (
    <main className={`${styles.page} ${styles.controle}`}>
      <header className={styles.entete}>
        <h1>{t('registrePolice.titre')}</h1>
        <Button onClick={() => void naviguer(`/${galerieSlug}/registre-police`)}>
          {t('registrePolice.quitterControle')}
        </Button>
      </header>
      <ListeRegistre galerieSlug={galerieSlug} controle peutLire={peutLire} />
    </main>
  );
}
